<template>
  <!-- 非優先選配區提醒（設計稿 NonPriorityDialog：警示圖 + 標題 + 內文 + 灰底 footer 重選/確認）-->
  <div class="ur-sel-modal-overlay" @click.self="$emit('close')">
    <div class="ur-sel-modal-box">
      <div class="ur-sel-modal-body">
        <WarnIcon />
        <h3 class="ur-sel-modal-title">{{ $t('URBANRENEWAL_SELECT.DIALOG.NONPRIORITY_TITLE') }}</h3>
        <p class="ur-sel-modal-text">{{ $t('URBANRENEWAL_SELECT.UNIT.NONPRIORITY_WARN') }}</p>
      </div>
      <div class="ur-sel-modal-footer">
        <button class="ur-sel-modal-btn ur-sel-modal-btn-secondary" type="button" @click="$emit('reselect')">
          {{ $t('URBANRENEWAL_SELECT.DIALOG.NONPRIORITY_RESELECT') }}
        </button>
        <button class="ur-sel-modal-btn ur-sel-modal-btn-primary" type="button" @click="$emit('confirm')">
          {{ $t('URBANRENEWAL_SELECT.DIALOG.NONPRIORITY_CONFIRM') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import WarnIcon from './WarnIcon.vue';

export default {
  name: 'UrbanRenewalSelectNonPriorityDialog',
  components: { WarnIcon },
};
</script>
